<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>Paciente</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">

      <div class="p-6">
        <!-- Name -->
        <vs-input name="name" v-model="name" label-placeholder="* Nome completo" class="mt-5 w-full" v-validate="'required'" icon-pack="feather" icon="icon-clipboard"/>
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <!-- Gender -->
        <div class="vs-component vs-con-input-label vs-input mt-5 w-full vs-input-primary is-label-placeholder">
          <p class="label">* Sexo</p>
          <ul class="">
            <li>
              <vs-radio color="#1263e6" v-model="gender" vs-value="Male">Masculino</vs-radio>
            </li>
            <li>
              <vs-radio color="#ed0cb9" v-model="gender" vs-value="Female">Feminino</vs-radio>
            </li>
          </ul>
          <span class="text-danger text-sm" v-show="errors.has('gender')">{{ errors.first('gender') }}</span>
        </div>

        <!-- BirthDate -->
        <div class="my-4">
          <vs-input hidden name="birthDate" v-model="birthDate" v-validate="'required|date_format:dd/MM/yyyy'"/>

          <p class="label">* Data de Nascimento</p>
          <flat-pickr :config="configdateTimePicker" v-model="birthDate" placeholder="selecione..." class="datetime-picker" icon-pack="feather" icon="icon-italic"/>
          <div>
            <span class="text-danger text-sm" v-show="errors.has('birthDate')">{{ errors.first('birthDate') }}</span>
          </div>
        </div>

        <!-- Observation -->
        <div>
          <vs-textarea label="Observação" cols="50" v-model="observation" class="mt-5 w-full" />
        </div>

        <!-- ForwardedBy -->
        <vs-input name="forwardedBy" v-model="forwardedBy" label-placeholder="Encaminhado" class="mt-5 w-full" icon-pack="feather" icon="icon-chevron-right"/>

        <!-- Email -->
        <vs-input name="email" v-model="email" label-placeholder="Email" class="mt-5 w-full" v-validate="'email'" icon-pack="feather" icon="icon-mail"/>
        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>

        <!-- Cpf -->
        <vs-input  name="cpf" v-model="cpf" label-placeholder="CPF" class="mt-5 w-full" v-validate="'digits:11'" icon-pack="feather" icon="icon-clipboard"/>
        <span class="text-danger text-sm" v-show="errors.has('cpf')">{{ errors.first('cpf') }}</span>

        <!-- PhoneNumber -->
        <vs-input  name="phoneNumber" v-model="phoneNumber" label-placeholder="Telefone" class="mt-5 w-full" icon-pack="feather" icon="icon-smartphone"/>

        <div class="my-4">
          <p class="label">* (Campo obrigatório)</p>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitForm">Enviar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Validator } from 'vee-validate';
import PatientService from "../../../services/PatientService";

const dict = {
  custom: {
    name: {
      required: 'Informe o nome completo.',
    },
    birthDate: {
      required: 'Informe a data de nascimento.',
      date_format: 'O formato da data deve ser: dd/MM/yyyy.',
    },
    gender: {
      required: 'Informe o sexo.',
    },
    email: {
      email: 'Informe um email válido.'
    }
  }
};

Validator.localize('en', dict);
export default {
  name: 'patient-form',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      name: '',
      birthDate: '',
      cpf: '',
      email: '',
      phoneNumber: '',
      gender: 'Male',
      observation: '',
      forwardedBy: '',
      //Config
      notifications: 
      {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        errors: this.errors,
        showSucces: false,
        showError: true
      },
      configdateTimePicker: {
        dateFormat: 'd/m/Y',
        noCalendar: false,
        allowInput: true
      },
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar');
          this.initValues();
        }
      }
    }
  },
  methods: {
    async submitForm() {
     this.$validator.validateAll().then(result => {
        if (result) {
          this.createPatient();
        } else {
          // form have errors
        }
      })
    },
    async createPatient() {
      this.$vs.loading();

      var payload = {
        data: {
          name: this.name,
          birthDate: this.toDate(this.birthDate),
          cpf: this.cpf,
          email: this.email,
          phoneNumber: this.phoneNumber,
          gender: this.gender,
          observation: this.observation,
          forwardedBy: this.forwardedBy
        },
        notifications: this.notifications
      };
      console.log(payload.data.birthDate);

      payload.notifications.showSucces = true;

      var result = await PatientService.create(payload);

      if(result.status == 200) {
        this.initValues();
        this.$emit('closeSidebar');
      }

      this.$vs.loading.close();
    },
    toDate (dateStr) {
      const [day, month, year] = dateStr.split("/");
      var date = new Date(Date.UTC(year, month -1, day));
      console.log(date);
      return date;
    },
    initValues() {
      this.name = '';
      this.birthDate = '';
      this.cpf = '';
      this.email = '';
      this.phoneNumber = '';
      this.gender = 'Male';
      this.observation = '';
      this.forwardedBy = '';
    }
  },
  components: {
    VuePerfectScrollbar,
    flatPickr,
    PatientService
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52004;
  }

  /deep/ .vs-sidebar {
    z-index: 52004;
    width: 400px;
    max-width: 90vw;
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}

.label {
  padding-left: 5px;
  font-size: .85rem;
  color: rgba(0,0,0,.7);
  margin-bottom: 2px;
}

.datetime-picker {
  width: 100%;
}
</style>